/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { getFile } from "actions";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";

class AnnouncementModalBody extends Component {
  state = { announcementImageFetched: false, file: null };

  componentDidMount() {
    this.fetchFile();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.imagePath !== prevProps.imagePath) {
      this.fetchFile();
    }
  };

  fetchFile = () => {
    if (this.props.imagePath) {
      this.props.getFile(
        this.props.imagePath,
        this.onBegin,
        this.onFileSuccess,
        this.onError
      );
    } else {
      this.setState({ announcementImageFetched: false });
    }
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onFileSuccess = (file) => {
    this.props.onProcessEnd();
    this.setState({
      announcementImageFetched: true,
      file: file,
    });
  };

  renderImage = () => {
    if (!this.state.announcementImageFetched) {
      return <div>{this.props.spinner}</div>;
    } else if (!this.state.file) {
      return null;
    }
    return (
      <img
        src={this.state.file.binary}
        className="img-fluid mb-3"
        alt="Duyuru 1"
      />
    );
  };

  render() {
    return (
      <>
        {this.renderImage()}
        <p>
          <b>{this.props.subject}</b>
        </p>
        <p>{this.props.detail}</p>
        {this.props.urlName ? (
          <div>
            <a href={this.props.url} rel="noopener noreferrer" target="_blank">
              <i
                className="fas fa-external-link-alt"
                style={{ color: "#2d96cd", marginRight: ".5rem" }}
              ></i>
              {this.props.urlName}
            </a>
          </div>
        ) : null}
      </>
    );
  }
}

// const mapStateToProps = (state, ownProps) => {
//   return {
//     file: state.files.find((f) => {
//       return f.id === ownProps.imagePath;
//     }),
//   };
// };

export default connect(null, { getFile })(
  containsLongRunningProcess(AnnouncementModalBody)
);

export const AnnouncementModalTitle = (props) => {
  let announcementType = "";
  switch (props.type) {
    case "Critical":
      announcementType = "-critical";
      break;
    case "Warning":
      announcementType = "-warning";
      break;
    default:
      announcementType = "";
      break;
  }

  return (
    <>
      <div className="duyuruIcon">
        <span
          className={`iconmford fo-icon-speaker-notes${announcementType}`}
        ></span>
      </div>
      <h5 className="modal-title">Duyuru</h5>
    </>
  );
};

export const AnnouncementModalFooter = (props) => {
  const handleNavigation = (newIdx) => {
    if (newIdx < 0) {
      props.selectAnnouncement(0);
    } else {
      props.selectAnnouncement(newIdx);
    }
  };
  return (
    <>
      <button
        className="btn btn-video float-left"
        data-dismiss="modal"
        onClick={() => handleNavigation(props.idx - 1)}
      >
        <span className="icon-icon-detail mr-2 left"></span> Önceki Duyuru
      </button>
      <button
        onClick={() => handleNavigation(props.idx + 1)}
        className="btn btn-video float-right"
        data-dismiss="modal"
      >
        Sonraki Duyuru <span className="icon-icon-detail ml-2"></span>
      </button>
    </>
  );
};
